import SEOHead from '../../components/base/SEOHead';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import MapSection from './components/MapSection';

export default function ContactPage() {
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contact KaliKare Homecare",
      "description": "Get in touch with KaliKare Homecare. Call us at 833-438-5542, email info@kalikarehomecare.com, or visit our office at 201 King of Prussia Rd, Suite 650, Radnor, PA 19087.",
      "url": `${baseUrl}/contact`,
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "KaliKare Homecare",
        "telephone": "+1-833-438-5542",
        "email": "info@kalikarehomecare.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "201 King of Prussia Rd, Suite 650",
          "addressLocality": "Radnor",
          "addressRegion": "PA",
          "postalCode": "19087",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "40.0459",
          "longitude": "-75.3771"
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "18:00"
          }
        ],
        "url": baseUrl
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Contact",
          "item": `${baseUrl}/contact`
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Contact KaliKare Homecare – Reach Us in Radnor, PA Today"
        description="Contact KaliKare Homecare in Radnor, PA. Call 833-438-5542, email info@kalikarehomecare.com, or visit 201 King of Prussia Rd, Suite 650, Radnor, PA 19087. We\u2019re here to help you find the right home care solution."
        canonical="/contact"
        jsonLd={jsonLd}
      />
      <Navbar />
      <ContactHero />
      <ContactForm />
      <ContactInfo />
      <MapSection />
      <Footer />
    </div>
  );
}
